import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import routes from "./routes/routes";
import {
    // Article,
    ArticleDetails,
    Comites,
    Credits,
    Home,
    Politique,
    Presentation,
    Proposition,
    Rubrique,
    Search
} from "./pages";
import { Layout } from "./components/Layout";
import { menuItems } from "./data/rubriqueMenu.data";
import './App.css';

// Importation des images
import homeHeroImage from "./assets/herobg/home-hero.webp";
import articleHeroImage from "./assets/herobg/article-hero.webp";
import rubriqueHeroImage from "./assets/herobg/rubrique-hero.webp";
import PropositionArticle from "./pages/PropositionArticle";
import allHeroImage from "./assets/herobg/all-hero.webp";

// Configuration des Heroes pour chaque page
const heroConfigs = {
    home: {
        image: homeHeroImage,
        title: "MADATLAS.",
        subtitle: "Cartes, images et données géographiques de Madagascar, de l'Océan Indien et des Afriques"
    },
    presentation: {
        image: allHeroImage,
        title: "Présentation",
        subtitle: ""
    },
    comites: {
        image: allHeroImage,
        title: "Les comités",
        subtitle: ""
    },
    politique: {
        image: allHeroImage,
        title: "Politique de Publication",
        subtitle: ""
    },
    proposition: {
        image: articleHeroImage,
        title: "Proposer un article",
        subtitle: ""
    },
    search: {
        image: articleHeroImage,
        title: "Recherche",
        subtitle: ""
    },
    credits: {
        image: allHeroImage,
        title: "Crédits",
        subtitle: ""
    },
    // article: {
    //     image: articleHeroImage,
    //     title: "Article",
    //     subtitle: ""
    // }
};

// Composant Wrapper pour les pages de rubrique avec titre dynamique
const RubriqueWrapper = () => {
    const { id } = useParams();

    console.log("from id", id);

    // Fonction de normalisation + formatage
    const normalizeToPluralTitle = (str) => {
        if (!str) return "";

        // Normalisation de base
        let clean = str
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") // accents
            .replace(/_/g, " ") // underscore → espace
            .replace(/\s+/g, " ") // espaces multiples → 1 espace
            .trim();

        // Mise en majuscule à chaque mot
        let formatted = clean
            .split(" ")
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");

        // Forcer pluriel
        if (!formatted.endsWith("s")) {
            formatted += "s";
        }

        return formatted;
    };

    const normalizedId = normalizeToPluralTitle(id);

    // Chercher rubrique correspondante en comparant formaté
    const foundRubrique = menuItems.find((item) => {
        const labelNorm = normalizeToPluralTitle(item.label);
        return labelNorm === normalizedId;
    });

    console.log("normalizedId:", normalizedId);
    console.log("from foundRubrique", foundRubrique);

    // Hero props dynamiques
    const dynamicHeroProps = {
        image: rubriqueHeroImage,
        title: foundRubrique ? normalizedId : "Rubrique", // titre corrigé
        subtitle: "",
    };

    return (
        <Layout heroProps={dynamicHeroProps} showSidebar={true}>
            <Rubrique />
        </Layout>
    );
};

function App() {
    useEffect(() => {
        const detectDevTools = (event) => {
            const threshold = 160;
            if (
                window.outerWidth - window.innerWidth > threshold ||
                window.outerHeight - window.innerHeight > threshold
            ) {
                console.log("%c** STOP **", "color: white; background-color: red; font-size: 16px; font-weight: bold; padding: 5px; border-radius: 5px;");
                console.log("%cThis is a browser feature intended for developers. Using this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS. Do not enter or paste code that you do not understand.", "color: red; font-weight: bold;");
            }

            if (event && (event.key === "F12" || (event.ctrlKey && event.shiftKey && event.key === "I") || (event.ctrlKey && event.key === "U"))) {
                event.preventDefault();
                console.log("%cAction non autorisée.", "color: red; font-weight: bold;");
            }
        };

        window.addEventListener("resize", detectDevTools);
        window.addEventListener("keydown", detectDevTools);
        document.addEventListener("contextmenu", (event) => event.preventDefault());

        const interval = setInterval(() => {
            console.log("%c** STOP **", "color: white; background-color: red; font-size: 48px; font-weight: bold; padding: 5px; border-radius: 5px;");
            console.log("%cThis is a browser feature intended for developers. Using this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS. Do not enter or paste code that you do not understand.", "color: red; font-weight: bold;");
        }, 5000);

        return () => {
            window.removeEventListener("resize", detectDevTools);
            window.removeEventListener("keydown", detectDevTools);
            document.removeEventListener("contextmenu", (event) => event.preventDefault());
            clearInterval(interval);
        };
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/">
                    <Route
                        path={routes.home}
                        element={
                            <Layout
                                heroProps={heroConfigs.home} showSidebar={true}
                            >
                                <Home />
                            </Layout>} />
                    <Route
                        path={routes.presentation}
                        element={
                            <Layout
                                heroProps={heroConfigs.presentation} showSidebar={true}
                            >
                                <Presentation />
                            </Layout>} />
                    <Route
                        path={routes.comites}
                        element={
                            <Layout
                                heroProps={heroConfigs.comites} showSidebar={true}
                            >
                                <Comites />
                            </Layout>} />
                    <Route
                        path={routes.politique}
                        element={
                            <Layout
                                heroProps={heroConfigs.politique} showSidebar={true}
                            >
                                <Politique />
                            </Layout>} />
                    <Route
                        path={routes.credits}
                        element={
                            <Layout
                                heroProps={heroConfigs.credits} showSidebar={true} showFooter={true}
                            >
                                <Credits />
                            </Layout>} />
                    <Route
                        path={routes.proposition} element={
                            <Layout heroProps={heroConfigs.proposition} showSidebar={true}
                            >
                                <Proposition />
                            </Layout>} />
                    <Route
                        path={routes.search} element={
                            <Layout heroProps={heroConfigs.search} showSidebar={true}
                            >
                                <Search />
                            </Layout>} />
                    {/*<Route*/}
                    {/*    path={routes.article}*/}
                    {/*    element={*/}
                    {/*        <Layout heroProps={heroConfigs.article} showSidebar={true}*/}
                    {/*        >*/}
                    {/*            <Article />*/}
                    {/*        </Layout>} />*/}
                    <Route
                        path={routes.propositionArticle} element={
                            <Layout heroProps={heroConfigs.proposition} showSidebar={false}
                            >
                                <PropositionArticle />
                            </Layout>} />
                    <Route
                        path={`${routes.article}/:id`} element={
                            <Layout showSidebar={true}>
                                <ArticleDetails />
                            </Layout>} />
                    <Route
                        path={`${routes.rubrique}/:id`} element={
                            <RubriqueWrapper />}
                    />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;